import { call, put, takeLatest } from "redux-saga/effects";
import { types } from "../action-types";
import { createProjectApi } from "../../API/API";

function* createProjectSaga(params) {
  try {
    const response = yield call(() => createProjectApi(params));
    yield put({ type: types.CREATE_PROJECT_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.CREATE_PROJECT_FAILURE, error });
  }
}

export function* watchCreateProjectSaga() {
  yield takeLatest(types.CREATE_PROJECT_INIT, createProjectSaga);
}
